import { defineFetch } from 'resift';

const makeGetValuesOfField = defineFetch({
  displayName: 'Get Values Of Field',
  make: (fieldObjectKey: string) => ({
    request: (aggSearchTerm?: string) => ({ http }) =>
      http({
        method: 'GET',
        route: `/metadata/${fieldObjectKey}`,
        query: {
          entityTypeTypeKey: 'user',
          aggSearchTerm,
          sortBy: 'popularity',
        },
      }),
  }),
});

export default makeGetValuesOfField;
